/**
 * Wordmark — the ROYALE wordmark atom (extraction signed off, tiered-exchange
 * D8 / refactor-log row 2026-07-28). One home for the treatment; rendered at
 * NEW sites only (the sans-chat landing card + the SP QR screens) — dormant
 * legacy copies (AnonLandingPage, QRScreen) keep their inline versions until
 * those surfaces are next touched.
 *
 * @param {Object} [style] - Optional style overrides (e.g. margins for placement)
 */
const Wordmark = ({ style }) => (
  <div
    style={{
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
      fontSize: '18px',
      fontWeight: '900',
      letterSpacing: '4px',
      color: '#000000',
      ...style,
    }}
  >
    ROYALE
  </div>
);

export default Wordmark;
